/*
  軽量なGoogle Analytics (gtag) ラッパー。
  - REACT_APP_GA_ID が指定されている場合のみ有効化
  - ない場合は no-op
*/

const GA_ID = process.env.REACT_APP_GA_ID;

let initialized = false;

function insertGtagScript(measurementId: string) {
  const existing = document.querySelector(`script[src*="gtag/js?id="]`);
  if (existing) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  const inline = document.createElement('script');
  inline.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
  `;
  document.head.appendChild(inline);
}

export function initAnalytics() {
  if (!GA_ID) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.info('[analytics] GA_ID が未設定のため、解析は無効化されています');
    }
    return;
  }
  if (initialized) return;
  insertGtagScript(GA_ID);
  (window as any).gtag && (window as any).gtag('config', GA_ID, {
    anonymize_ip: true,
    send_page_view: false,
  });
  initialized = true;
}

export function trackPageview(path: string) {
  if (!GA_ID) return;
  const gtag = (window as any).gtag;
  if (typeof gtag === 'function') {
    gtag('event', 'page_view', {
      page_path: path,
    });
  }
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  if (!GA_ID) return;
  const gtag = (window as any).gtag;
  if (typeof gtag === 'function') {
    gtag('event', eventName, params || {});
  }
}

export function isAnalyticsEnabled() {
  return Boolean(GA_ID);
}


